ACC.cms = {

  bindAll: function() {
    this.bindNavigationBarMenu();
  },

  bindNavigationBarMenu: function() {
    $('li.La ul ul a').each(function() {
      $(this).focus(function() {
        $(this).addClass('focused');

        var menuParent = $(this).closest('ul').parent().closest('ul');

        $(menuParent).addClass('dropdown-visible');
      });

      $(this).blur(function() {
        $(this).removeClass('focused');

        var menuParent = $(this).closest('ul').parent().closest('ul');

        /* eslint-disable  unicorn/explicit-length-check */
        if (!$('.focused', menuParent).length) {
        /* eslint-enable  unicorn/explicit-length-check */
          $(menuParent).removeClass('dropdown-visible');
        }
      });
    });
  },
  checkPreviewandBankClick: function() {
    if (document.querySelector('.getfilechangechangeEvntBank')) {
      document.querySelector('.getfilechangechangeEvntBank').addEventListener('change', function() {
        ACC.fileuploadcommon.getFileChange(this, '', 'bankReference');
      });
    }

    if (document.querySelector('.getfilechangechangeEvntPreview')) {
      document.querySelector('.getfilechangechangeEvntPreview').addEventListener('change', function() {
        ACC.fileuploadcommon.getFileChange(this, '', 'preview');
      });
    }
  }

};

$(document).ready(function() {
  ACC.cms.bindAll();
  $(document).on('click', '.customOnClick', function() {
    var fnName = $(this).attr('fnName');
    var fnAttr = $.trim($(this).attr('fnAttr'));

    if (fnName && fnAttr !== '' && window[fnName]) {
      window[fnName](fnAttr);
    } else if (fnName && window[fnName]) {
      window[fnName]();
    }
  });
  $(document).on('click', '.clkfileToUpload', function() {
    document.getElementById('fileToUpload').click();
  });
  $(document).on('click', '.clkReturnFalse', function() {
    return false;
  });
  $(document).on('click', '.clkRecCheckout', function() {
    ACC.omniture.bindTrackConversion('interaction', 'checkout');
    ACC.bundleproducts.validateconfiguration('');
  });
  $(document).on('click', '.footercookiebar', function() {
    if (philips && philips.cookiebar && typeof philips.cookiebar.openConsentManager === 'function') {
      philips.cookiebar.openConsentManager();
    }
  });
  $(document).on('click', '.clearinputsnow', function() {
    $('input.text').val('');
    $('input.left').val('');
    $('select').prop('selectedIndex', 0);
    document.forms.registerForm.elements[0].focus();
  });
  $(document).on('click', '.myfavclickevnt', function() {
    $('#favRemoveCode').val($(this).attr('data-productid'));
    $('#removeFavForm').submit();
  });
  $(document).on('click', '.importpageGetFile', function() {
    document.getElementById('getFile').click();
  });
  $(document).on('change', '.facetNavchangeEvnt', function() {
    $(this).closest('form').submit();
  });


  if (document.querySelector('.getfilechangechangeEvnt')) {
    document.querySelector('.getfilechangechangeEvnt').addEventListener('change', function() {
      ACC.fileupload.getFileChange(this);
    });
  }

  if (document.querySelector('.getfilechangeRegisterEvent')) {
    document.querySelector('.getfilechangeRegisterEvent').addEventListener('change', function() {
      ACC.registerPage.getFileChangeRegister(this);
    });
  }

  ACC.cms.checkPreviewandBankClick();

  $(document).on('click', '.allFacetValuesClk', function() {
    $(this).closest('div.allFacetValues').hide().siblings('div.topFacetValues').show();
  });
  $(document).on('click', '.topFacetValuesClk', function() {
    $(this).closest('div.topFacetValues').hide().siblings('div.allFacetValues').show();
  });
  $(document).on('click', '.allFacetValuesEvnt', function() {
    $(this).closest('div.allFacetValues').find('li.hidden').slice(0, 5).removeClass('hidden');
  });
  $(document).on('click', '.searchLocationEvnt', function() {
    $(this).closest('div.search_location').hide();
    $(this).parent().siblings().closest('div.search_no_location').show();
    $(this).parent().siblings().find('div.allFacetValues').hide();
  });
});


